import api, { paginado } from './apiClient'

/**
 * Sincronização legado × banco novo (Épicos 19 e 26).
 *
 * `/sync/status`, `/sync/failures` e `/sync/run` são rotas de **operação**: no
 * back-end elas exigem `sincronizacao.*` E a role `admin`, porque enxergam
 * todas as filiais de todos os clientes. `/sync/consistency` é a única
 * recortada pelas filiais do usuário — por isso a tela trata 403 nas primeiras
 * sem derrubar a última.
 */

/** Entidades que o motor de sincronização conhece (`ENTIDADES_SINCRONIZAVEIS`). */
export const ENTIDADES = [
  { valor: 'process_flow', rotulo: 'Fluxos de produção' },
  { valor: 'production_order', rotulo: 'Ordens de produção' },
  { valor: 'production_break', rotulo: 'Quebras de produção' },
  { valor: 'break_stage_event', rotulo: 'Eventos de etapa' },
  { valor: 'rfid_item', rotulo: 'Itens RFID' },
]

const ROTULO_DA_ENTIDADE = ENTIDADES.reduce(
  (mapa, item) => ({ ...mapa, [item.valor]: item.rotulo }),
  {}
)

export const rotuloDaEntidade = valor => ROTULO_DA_ENTIDADE[valor] || valor

/** `GET /sync/status` — estado por entidade, sem paginação. */
export const getSyncStatus = async () => {
  const response = await api.get('/sync/status')
  return { data: { result: response.data?.items ?? [] } }
}

/** `GET /sync/failures` — falhas pendentes (ou também resolvidas). */
export const getSyncFailures = async ({
  entidade = '',
  incluirResolvidas = false,
  limit = 50,
  offset = 0,
} = {}) => {
  const response = await api.get('/sync/failures', {
    params: {
      ...(entidade ? { entidade } : {}),
      incluirResolvidas,
      limit,
      offset,
    },
  })
  return { data: paginado(response) }
}

/** `POST /sync/run` — sem `entidade`, roda todas. */
export const runSync = async ({ entidade = '', limite } = {}) => {
  const response = await api.post('/sync/run', {
    ...(entidade ? { entidade } : {}),
    ...(limite ? { limite } : {}),
  })
  return { data: response.data }
}

/** `POST /sync/failures/:id/retry` — rebusca o registro na origem e reaplica. */
export const retrySyncFailure = async id => {
  const response = await api.post(`/sync/failures/${id}/retry`)
  return { data: response.data }
}

/** `GET /sync/consistency` — contagem e amostra de campos, origem × destino. */
export const getConsistency = async () => {
  const response = await api.get('/sync/consistency')
  return { data: response.data }
}
